import React, { useState } from "react";
import {
  StyledContainerBodyProfessionalWay,
  StyledContainerProfessionalWay,
} from "./ProfessionalWay.styled";
import {
  Accordion,
  AccordionVariantEnum,
} from "../../../../../components/core/Accordion/Accordion";
import { FontWeightEnum, IconSizeEnum } from "../../../../../types/AppTypes";
import {
  ACTION_PLAN_LABEL,
  EMPTY_STRING,
  FOCUS_GOAL_LABEL,
  PROFESSIONAL_PATH_LABEL,
} from "../../../../../constants/Dictionary";
import { BodyTyp } from "../../../../../components/Typography/Typography";
import { IconManager } from "../../../../../components/core/IconManager/IconManager";
import { StyledWorkInformationBody } from "../Resume.styled";
import { CollaboratorResume } from "../../../../../types/api/collaborators.type";
import { ReactComponent as ProfessionalWayIcon } from "../../../../../icons/professionalWay.svg";

export const ProfessionalWay = ({
  resumeData,
}: {
  resumeData?: CollaboratorResume;
}) => {
  const [isAccordionOpen, setIsAccordionOpen] = useState(true);

  return (
    <StyledContainerProfessionalWay>
      <Accordion
        label={
          <BodyTyp variant="2" fontWeight={FontWeightEnum.SEMIBOLD}>
            {PROFESSIONAL_PATH_LABEL.toUpperCase()}
          </BodyTyp>
        }
        variant={AccordionVariantEnum.SECONDARY}
        leftComponent={
          <IconManager size={IconSizeEnum.SMALL}>
            <ProfessionalWayIcon />
          </IconManager>
        }
        onToggle={setIsAccordionOpen}
        isOpen={isAccordionOpen}
      >
        <StyledContainerBodyProfessionalWay>
          <BodyTyp variant="2" fontWeight={FontWeightEnum.SEMIBOLD}>
            {FOCUS_GOAL_LABEL}
          </BodyTyp>
          <StyledWorkInformationBody>
            <BodyTyp variant="2" fontWeight={FontWeightEnum.REGULAR}>
              {resumeData?.professionalWay.developmentGoalFocus ?? EMPTY_STRING}
            </BodyTyp>
          </StyledWorkInformationBody>
          <BodyTyp variant="2" fontWeight={FontWeightEnum.SEMIBOLD}>
            {ACTION_PLAN_LABEL}
          </BodyTyp>
          <StyledWorkInformationBody>
            <BodyTyp variant="2" fontWeight={FontWeightEnum.REGULAR}>
              {resumeData?.professionalWay.actionPlan ?? EMPTY_STRING}
            </BodyTyp>
          </StyledWorkInformationBody>
        </StyledContainerBodyProfessionalWay>
      </Accordion>
    </StyledContainerProfessionalWay>
  );
};
